import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Config } from '../config';
import { Logger } from './logger';

@Injectable({ providedIn: 'root' })
export class ExceptionService {
  constructor(private router: Router, private toastr: ToastrService) { }
  catchBadResponse(errorResponse: any): Observable<any> {
    const err = <HttpErrorResponse>errorResponse;

    // TODO : send the error to the API for reports and aggregations
    if (err && err.status === 302) {
      this.toastr.info('Reloading the current page', 'Authentication required');
      window.location.reload();
    } else if (err && err.status === 400) {
      this.toastr.info('Please search again', 'Bad Data');
      this.router.navigate([`/FDC/page-bad-data`]);
    } else if (err && err.status === 404) {
      this.router.navigate([`/FDC/page-not-found`]);
    } else if (
      err &&
      (err.status < 200 || err.status <= 300 || err.status >= 500)
    ) {
      console.log('Error status '+err.status+" loading url="+err.url);
      this.toastr.error(
        'Please contact administrator or try again',
        'Something went wrong!'
      );
      this.router.navigate([`/FDC/error`]);
    }

    return of(false);
  }
}
